"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitFor = void 0;
const defaultOptions = {
    timeout: 1000,
    interval: 50,
};
const waitFor = async (callback, options = defaultOptions) => {
    const { timeout = 1000, interval = 50 } = options;
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
        const checkCondition = () => {
            try {
                callback();
                resolve();
            }
            catch (error) {
                if (Date.now() - startTime >= timeout) {
                    reject(new Error(`Timed out in customWaitFor after ${timeout}ms.`));
                }
                else {
                    setTimeout(checkCondition, interval);
                }
            }
        };
        checkCondition();
    });
};
exports.waitFor = waitFor;
//# sourceMappingURL=index.js.map